module.exports = __webpack_public_path__ + "static/media/iPhone14-2.400cdc0f.png";